import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateDatasetMarkdownState from './datasetMarkdown';
import updateDatasetState from './dataset';

const handlers = {
  ...updateDatasetMarkdownState,
  ...updateDatasetState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
